const ELIGBLE_GOOGLE_TYPES = [
    'administrative_area_level_1',
    'administrative_area_level_2',
    'administrative_area_level_3',
    'administrative_area_level_4',
    'administrative_area_level_5',
    'colloquial_area',
    'country',
    'establish,ment',
    'geocode',
    'locality',
    'natural_feature',
    'neighborhood',
    'place_of_worship',
    'point_of_interest',
    'premise',
    'street_address',
    'street_number',
    'sublocality',
    'sublocality_level_4',
    'sublocality_level_5',
    'sublocality_level_3',
    'sublocality_level_2',
    'sublocality_level_1',
    'subpremise'
];

export const filterEligbleGoogleResults = (results) => {
    return results.filter((result) => {
        return ELIGBLE_GOOGLE_TYPES.some(
            (element) => result.types.indexOf(element) >= 0
        );
    });
};
